// Active sur .dropzone[data-dropzone]
document.querySelectorAll('.dropzone[data-dropzone]').forEach(zone => {
    const input = zone.querySelector('input[type="file"]') || (() => {
        const i = document.createElement('input'); i.type = 'file'; i.multiple = true; i.hidden = true;
        zone.appendChild(i); return i;
    })();
    const list = zone.querySelector('.dropzone__list') || (() => {
        const ul = document.createElement('ul'); ul.className = 'dropzone__list'; zone.appendChild(ul); return ul;
    })();

    function showFiles(files) {
        list.innerHTML = '';
        [...files].forEach(f => {
            const li = document.createElement('li');
            li.textContent = `${f.name} (${Math.round(f.size/1024)} KB)`;
            list.appendChild(li);
        });
    }

    // Click -> ouvre l’explorateur
    zone.addEventListener('click', () => input.click());

    // Drag & drop
    ['dragenter','dragover'].forEach(evt =>
        zone.addEventListener(evt, e => { e.preventDefault(); e.stopPropagation(); zone.classList.add('is-dragover'); })
    );
    ['dragleave','drop'].forEach(evt =>
        zone.addEventListener(evt, e => { e.preventDefault(); e.stopPropagation(); zone.classList.remove('is-dragover'); })
    );
    zone.addEventListener('drop', e => { const files = e.dataTransfer?.files || []; input.files = files; showFiles(files); });
    input.addEventListener('change', () => showFiles(input.files || []));
});
